/** Presentation only: keep Shopify Forms' teaser clear of mobile actions.
 * App step, signup fields, consent and event delivery remain app-owned.
 */
(() => {
  'use strict';
  const stylesheet = document.currentScript?.dataset.stylesheet;
  if (!stylesheet) return;
  const selector = 'shopify-forms-embed#app-embed-container-1186415';

  function install() {
    const host = document.querySelector(selector);
    const root = host?.shadowRoot;
    if (!root) return false;
    if (root.querySelector('link[data-etr-floating-controls]')) return true;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = stylesheet;
    link.dataset.etrFloatingControls = '';
    root.append(link);
    host.toggleAttribute('data-etr-product-page', Boolean(document.querySelector('[data-etr-pdp]')));
    host.toggleAttribute('data-etr-cart-checkout', Boolean(document.querySelector('.etr-cart__mobile-checkout')));
    return true;
  }

  // Shadow attachment emits no light-DOM mutation. Bound readiness retries to
  // the initial minute, then stop; no scroll listener or lifetime polling.
  const deadline = Date.now() + 60000;
  function ready() {
    if (!install() && Date.now() < deadline) setTimeout(ready, 250);
  }
  ready();
})();
